module.exports = __webpack_public_path__ + "img/email.2b1adc4b.png";